import {
  Header,
  SearchFilterWrapper,
  setDateFromStorage,
  HeaderFilterContainer,
  TypeSelectorAndSearch,
  SearchSelectResponsive,
  useTranslation
} from '@fareye/common'
import { IKeyValue, IDateRange } from '@fareye/types'
import { DatePicker, Flex, SearchSelect, Span } from '@fareye/ui'
import {
  dMmm,
  getQueryParams,
  getSearchFilterFromSession,
  yyyyMmDd,
  snakeCase,
  MdFilterList
} from '@fareye/utils'
import queryString, { ParsedQuery } from 'query-string'
import React from 'react'
import { mapping } from '../../../config/mapComponents'

export function ContainerStatusListing({
  match,
  config,
  history,
  location,
  maxRefreshCount,
  refreshInterval,
  routesConfig
}: any) {
  const searchParams: ParsedQuery<string | Date> = queryString.parse(
    location.search
  )
  const {
    carryDate,
    showDatePicker,
    showTimezone,
    additionalDays = 0
  } = config.config
  const { t } = useTranslation()
  const { styling, globalSearchPageId } = config
  const { bodyBgColor, layoutStyle } = styling
  const [globalSearch, setGlobalSearch] = React.useState(
    getSearchFilterFromSession(globalSearchPageId)
  )

  const [dateRange, setDateRange] = React.useState(() => {
    return setDateFromStorage({
      showDatePicker: !!showDatePicker,
      carryDate,
      searchParams,
      daysDiff: 20
    })
  })

  const { startDate, endDate } = dateRange as IDateRange<Date>

  React.useEffect(() => {
    if (showDatePicker) {
      let prevStartDate = searchParams.startDate
      let prevEndDate = searchParams.endDate
      if (prevStartDate !== startDate || prevEndDate !== endDate) {
        const queryParams = getQueryParams({
          ...queryString.parse(location.search),
          startDate,
          endDate
        })
        history.replace({
          pathname: match.url,
          search: queryParams
        })
      }
    }
  }, [dateRange])

  function setDateRangeAndStorage(dates: IDateRange<string | Date>) {
    localStorage.setItem('date', JSON.stringify(dates))
    setDateRange(dates as IDateRange<Date>)
  }

  const { component } = config.children
  const ComponentRender = (mapping as any)[component]

  const apiFilter = config?.filters?.apiFilter

  let maxDate = new Date()
  maxDate.setDate(maxDate.getDate() + additionalDays)
  return (
    <Flex column style={{ ...layoutStyle, height: '100%' }}>
      <Header
        match={match}
        startDate={startDate}
        endDate={endDate}
        location={location}
        history={history}
        routesConfig={routesConfig}
        rightTopCorner={
          showDatePicker ? (
            <Flex>
              <DatePicker
                variant="fareyeV2"
                formatter={yyyyMmDd}
                onDateRangeSelected={setDateRangeAndStorage}
                value={dateRange}
                maxDate={maxDate}
              />
            </Flex>
          ) : null
        }
        showTimezone={showTimezone}
      >
        <HeaderFilterContainer>
          <SearchFilterWrapper
            apiFilter={apiFilter}
            customKeyMapping={(config.filters as any)?.customKeyMapping}
            apiFav={config?.filters?.apiFav}
            pageId={globalSearchPageId}
            search={globalSearch}
            setSearch={setGlobalSearch}
            startDate={startDate}
            endDate={endDate}
            showTimezone={showTimezone}
          />
        </HeaderFilterContainer>
      </Header>
      <div style={{ flexGrow: 1, background: bodyBgColor }}>
        <div
          style={{
            flexGrow: 1,
            background: bodyBgColor,
            padding: '10px 15px'
          }}
        >
          <ComponentRender
            match={match}
            history={history}
            mapping={mapping}
            location={location}
            maxRefreshCount={maxRefreshCount}
            refreshInterval={refreshInterval}
            endDate={showDatePicker ? endDate : null}
            startDate={showDatePicker ? startDate : null}
            showDatePicker={showDatePicker}
            config={config.children}
            globalSearch={globalSearch}
            showTimezone={showTimezone}
          />
        </div>
      </div>
    </Flex>
  )
}
